<template>
    <div>
        <vx-card title="PRODUTOS MAIS VENDIDOS">
            <div slot="no-body">
                <div class="line-area-chart">
                    <vue-apex-charts type="pie" height="360" :options="pieChart.chartOptions" :series="pieChart.series"></vue-apex-charts>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>
    import VueApexCharts from 'vue-apexcharts'

    export default {
        props : ['productsData'],

        components : {
            VueApexCharts
        },

        data () {
            return {
                themeColors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
                pieChart: {
                    series: [],
                    chartOptions: {
                        plotOptions: {
                            pie: {
                                legend : {
                                    show: false
                                },
                                customScale: 1
                            }
                        },
                        labels: [],
                        colors: this.themeColors,
                        responsive: [{
                            breakpoint: 480,
                            options: {
                                legend: {
                                    show : false,
                                    position: 'bottom'
                                }
                            }
                        }]
                    }
                }
            }
        },

        created () {
            this.changeChart()
        },

        methods : {
            changeChart () {
                let newProducts = [];

                this.productsData.forEach(doc => {
                    let data = doc.data()
                    
                    if(data.hasOwnProperty('products')) 
                        if(data.products.hasOwnProperty('product')) {
                            let products = Object.entries(data.products.product)

                            products.forEach(product => {
                                if(newProducts[product[0]])
                                    newProducts[product[0]].quantity += product[1].quantity
                                 else 
                                    newProducts[product[0]] = { description : product[1].description, quantity : product[1].quantity }
                            })
                        }
                })

                let sortedProducts = Object.entries(newProducts).sort((a,b) => b[1].quantity - a[1].quantity)
                let newsProducts = []
                sortedProducts.forEach((product, i) => {
                    if(i <= 13) newsProducts.push(product)
                })

                let labels = []
                let series = []
                newsProducts.forEach(product => {
                    labels.push(product[1].description)
                    series.push(product[1].quantity)
                })

                this.$set(this.pieChart, 'series', series)
                this.$set(this.pieChart.chartOptions, 'labels', labels)
            }
        }
    }
</script>